"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = a;
exports.default = exports.defaultProps = void 0;

var _tabFocus = require("./tab-focus");

var _hover = require("./hover");

var defaultProps = {
  '$link-color': '#0275d8',
  '$link-decoration': 'none',
  '$link-hover-color': '#014C8D',
  '$link-hover-decoration': 'underline',
  '$enable-hover-media-query': false
};
/**
 * @public
 * @description Basic css for Anchor component.
 * @param {string} $linkColor
 * @param {string} $linkDecoration
 * @param {string} $linkHoverColor
 * @param {string} $linkHoverDecoration
 * @param {boolean} $enableHoverMediaQuery
 * @returns {string}
 */

exports.defaultProps = defaultProps;

function a() {
  var $linkColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps['$link-color'];
  var $linkDecoration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProps['$link-decoration'];
  var $linkHoverColor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProps['$link-hover-color'];
  var $linkHoverDecoration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultProps['$link-hover-decoration'];
  var $enableHoverMediaQuery = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultProps['$enable-hover-media-query'];
  return "\n    color: ".concat($linkColor, ";\n    text-decoration: ").concat($linkDecoration, ";\n    background-color: transparent;\n    -webkit-text-decoration-skip: objects;\n  \n    ").concat((0, _hover.hoverFocus)($enableHoverMediaQuery, "\n      color: ".concat($linkHoverColor, ";\n      text-decoration: ").concat($linkHoverDecoration, ";\n    ")), "\n    \n    &:focus {\n      ").concat((0, _tabFocus.tabFocus)(), "\n    }\n\n    a:not([href]):not([tabindex]) {\n      color: inherit;\n      text-decoration: none;\n      \n      ").concat((0, _hover.hoverFocus)($enableHoverMediaQuery, "\n        color: inherit;\n        text-decoration: none;\n      "), "\n\n      &:focus {\n        outline: 0;\n      }\n    }\n  ");
}

var _default = {
  defaultProps: defaultProps,
  a: a
};
exports.default = _default;